const IconComponent = ({ icon }) => {
  return <div className="p-2 rounded bg-on-bg-brand">{icon}</div>
}

export default IconComponent
